var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14467_24269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 29.3333L32 37.3333L53.3333 16",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3307 32.0003V48.0003C53.3307 49.4148 52.7688 50.7714 51.7686 51.7716C50.7684 52.7718 49.4119 53.3337 47.9974 53.3337H15.9974C14.5829 53.3337 13.2264 52.7718 12.2262 51.7716C11.226 50.7714 10.6641 49.4148 10.6641 48.0003V16.0003C10.6641 14.5858 11.226 13.2293 12.2262 12.2291C13.2264 11.2289 14.5829 10.667 15.9974 10.667H39.9974",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14467_24269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.278eb7f69eeb8198846468c318b6e4cd.svg";
export { ForwardRef as ReactComponent };